/**
 * Created by staffanrantzow on 16/03/16.
 */

/* @flow */
import { proxyCounterpart } from '../../../../scripts/proxyCounterpart';
import React, {PropTypes } from 'react';
import Translate from 'react-translate-component';
import { SelectBox } from 'components';
import { UserSettingsConstants } from 'frilans-finans';

export class ItpVacationCheckBoxes extends React.Component {

  static propTypes = {
    values: PropTypes.object.isRequired,
    callback: PropTypes.func.isRequired,
    disableITP: PropTypes.bool.isRequired,
    showErrorWithoutBlur: PropTypes.bool.isRequired
  };

  constructor (props) {
    super(props);

    const itpDefaultAsPercent = UserSettingsConstants.itpRateDefault * 100;
    const defaultClasses = 'styled-wrapper right';

    // Create options from 0.5 to 20
    const itpRateOptions = [ {value: UserSettingsConstants.itpRateDefault, key: itpDefaultAsPercent + '% (standard)'} ];
    for (let i = 5; i <= 35; i++) {
      itpRateOptions.push({
        value: i / 100,
        key: i + '%'
      });
    }

    this.state = {
      values: this.props.values,
      itpRateOptions,
      defaultClasses
    };

    this.callCallback = this.callCallback.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.renderItp = this.renderItp.bind(this);
    this.renderItpRates = this.renderItpRates.bind(this);
    this.renderItpSetting = this.renderItpSetting.bind(this);
  }

  handleClick (e) {
    var values, name;

    values = this.state.values;
    name = e.target.name;

    values[name].value = e.target.checked;

    this.setState({values: values}, function () {
      this.callCallback(name, values[name]);
    });
  }

  /**
   * Required function when you have the checked attribute on a checkbox
   */
  onChange (e) {}

  callCallback (name, obj) {
    this.props.callback(name, obj);
  }

  renderItpRates () {
    if (this.state.values.saveITP.value) {
      return (
        <div className='input-wrapper margin-multiple-rows'>
          <SelectBox name='itpRate' options={this.state.itpRateOptions}
            callback={this.callCallback} errorMessage={proxyCounterpart('CALC_KEY_ERROR')}
            required='true' value={this.state.values.itpRate.value}
            showErrorWithoutBlur={this.props.showErrorWithoutBlur} />
        </div>
      );
    }
  }

  renderItpSetting () {
    if (this.state.values.canChangeItp.value) {
      return (
        <div className={this.state.defaultClasses}>
          <input id='saveITP' type='checkbox' name='saveITP' onChange={this.onChange}
            value={this.state.values.saveITP.value}
            checked={this.state.values.saveITP.value} onClick={this.handleClick}
          />
          <label htmlFor='saveITP'>
            <span></span>
            <Translate content='SAVE_PENSION_CHECKBOX'/>
          </label>
        </div>
      );
    }
  }

  renderItp () {
    if (!this.props.disableITP) {
      return (
        <div className="section">
          <h3>
            <Translate content='ITP'/>
            <a
              href='https://www.frilansfinans.se/fragor-och-svar/tjanstepension/'
              target='_blank'
            ><Translate content='ITP_READ_MORE'/>
            </a>
          </h3>
          {this.renderItpSetting()}
          {this.renderItpRates()}
        </div>
      );
    }
  }

  render () {
    return (
      <div className='setting-checkboxes'>
        {this.renderItp()}
        <div className="section">
          <h3>
            <Translate content='VACATION_MONEY'/>
            <a
              href='https://www.frilansfinans.se/fragor-och-svar/semesterersattning/'
              target='_blank'
            ><Translate content='VACATION_MONEY_READ_MORE'/>
            </a>
          </h3>
          <div className={this.state.defaultClasses}>
            <input id='saveVacationPay' type='checkbox' name='saveVacationPay' onChange={this.onChange}
              value={this.state.values.saveVacationPay.value}
              checked={this.state.values.saveVacationPay.value} onClick={this.handleClick} />
            <label htmlFor='saveVacationPay'>
              <span className="right"></span>
              <Translate content='SAVE_VACATION_CHECKBOX'/>
            </label>
          </div>
        </div>

      </div>
    );
  }
}

export default ItpVacationCheckBoxes;



/** WEBPACK FOOTER **
 ** ./src/views/settings/salary-info/check-boxes/itp_vacation.js
 **/